export default __webpack_public_path__ + "static/media/WNo.6-1.ea2aac57.jpg";